<template>
<v-dialog transition="dialog-bottom-transition" max-width="450" v-model="dialog" activator=".dialogActivator" >
    <v-card class="tw-relative">
        <v-toolbar class="tw-font-sans tw-z-20" color="#282828" dark>
            Entre para Continuar
            <v-spacer />
            <a href="#" @click="dialog = false" class="tw-text-white"><i class="fas fa-times"></i></a>
        </v-toolbar>
        <div class="tw-w-full tw-h-full tw-absolute tw-bg-black tw-bg-opacity-10 tw-flex tw-items-center tw-justify-center tw-top-0 tw-left-0 tw-z-10" v-if="loading">
            <v-progress-circular indeterminate :width="3" color="purple" />
        </div>
        <div class="tw-px-10 tw-mb-8">
            <h3 class="tw-font-sans tw-text-center tw-w-full tw-text-2xl tw-font-bold tw-my-8">LOGIN</h3>
            <v-alert dense dismissible text type="error" v-model="error">{{errorText}}</v-alert>
            <div class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
                <div class="tw-w-full">
                    <a href="#" @click="popupProvider('google')" v-ripple class="tw-border tw-rounded tw-border-opacity-10 tw-border-white tw-py-2 tw-text-center tw-text-sm tw-font-sans tw-block tw-text-white tw-font-medium">
                        <i class="fab fa-google tw-text-red-700 tw-mr-1"></i>
                        Google
                    </a>
                </div>
                <div class="tw-w-full tw-mt-2">
                    <a href="#" @click="popupProvider('facebook')" v-ripple class="tw-border tw-rounded tw-border-opacity-10 tw-border-white tw-py-2 tw-text-center tw-text-sm tw-font-sans tw-block tw-text-white tw-font-medium">
                        <i class="fab fa-facebook-square tw-text-blue-700 tw-mr-1"></i>
                        Facebook
                    </a>
                </div>
            </div>
            <!-- <p class="tw-mt-3 tw-mb-3 tw-text-opacity-40 tw-text-white tw-w-full tw-text-center">Ou entre com</p>
            <form @submit.prevent="login()" ref="loginForm" class="tw-mb-10">
                <v-text-field type="email" label="Email" v-model="form.email" filled class="tw-font-sans" prepend-inner-icon="mdi-email-outline"></v-text-field>
                <v-text-field type="password" label="Senha" v-model="form.password" filled class="tw-font-sans" prepend-inner-icon="mdi-lock-outline"></v-text-field>
                <button type="submit" v-ripple class="tw-font-sans tw-tracking-widest tw-text-xs tw-text-black tw-uppercase tw-text-center tw-w-full tw-block tw-rounded tw-py-3 tw-bg-white focus:tw-bg-white focus:tw-outline-none">Entrar</button>
            </form> -->
        </div>
    </v-card>
</v-dialog>
</template>

<script>
import EventBus from '@/eventbus';
import firebase from 'firebase';
export default {
    data(){
        return{
            clickFollow: false,
            toggle: false,
            loading: false,
            dialog: false,
            error: false,
            errorText: '',
            form:{
                email: '',
                password: '',
            },
            redirectTo: '',
        }
    },
    methods: {
        login(){
            this.loading = true;
            firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password).then(
                (user) => {
                    this.form.uid = user.user.uid;
                    this.form.displayName = user.user.displayName;
                    this.form.photoURL = user.user.photoURL;
                    this.$inertia.post('/backstage/login', {
                        uid: user.user.uid,
                        displayName: user.user.displayName,
                        photoURL: user.user.photoURL,
                        email: this.form.email,
                        password: this.form.password
                    }).then((res) => {
                        this.loading = false;
                        this.form.password = '';
                        this.form.email = '';
                        this.dialog = false;
                        if(this.redirectTo.length){
                            window.open(this.redirectTo, '_blank');
                        }
                    });
                },
                (err) => {
                    this.loading = false;
                    this.error = true;
                    switch (err.code) {
                        case 'auth/wrong-password':
                            this.errorText = 'Senha ou email inválido.';
                            break;

                        case 'auth/too-many-requests':
                            this.errorText = "O acesso a essa conta foi temporariamente desabilitado devido a diversas tentativas de login malsucedidas. Tente novamente mais tarde."
                            break;
                        
                        case 'auth/user-not-found':
                            this.errorText = 'Usuário não encontrado.'
                            break;
                    
                        default:
                            break;
                    }
                }
            );
        },
        popupProvider(value){
            this.loading = true;
            switch (value) {
                case 'google':
                    var provider = new firebase.auth.GoogleAuthProvider();
                    break;
                
                case 'facebook':
                    var provider = new firebase.auth.FacebookAuthProvider();
                    break;
            
                default:
                    var provider = new firebase.auth.GoogleAuthProvider();
                    break;
            }

            firebase.auth().signInWithPopup(provider).then(
                (user) => {
                    this.$inertia.post('/backstage/login', {
                        uid: user.user.uid,
                        displayName: user.user.displayName, 
                        photoURL: user.user.photoURL,
                        email: user.user.email,
                    }).then((res) => {
                        this.loading = false;
                        this.dialog = false;
                        if(this.clickFollow){
                            EventBus.$emit('followUser');
                        }
                    });
                },
                (err) => {
                    this.loading = false;
                    switch (err.code) {
                        case 'auth/popup-closed-by-user':
                            this.$page.message = 'Popup fechado pelo usuário.';
                            break;

                        case 'auth/too-many-requests':
                            this.errorText = "O acesso a essa conta foi temporariamente desabilitado devido a diversas tentativas de login malsucedidas. Tente novamente mais tarde."
                            break;
                        
                        case 'auth/user-not-found':
                            this.errorText = 'Usuário não encontrado.'
                            break;
                    
                        default:
                            console.log(err);
                            break;
                    }
                }
            );
        },
    },
    mounted(){
        firebase.auth().languageCode = 'pt-BR'
        EventBus.$on('activatePopup', e =>{
            this.dialog = true;
            if(e.redirectTo){
                this.redirectTo = e.redirectTo;
            }
        });
        EventBus.$on('clickFollow', (data) => {
            this.clickFollow = true;
        });
    }
}
</script>

<style>
</style>